import React, { useState } from "react";
import {
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { delete_booking_dynamic_route } from "../auth/service";
import { toast, ToastContainer } from "react-toastify";

const CardPageCategory = ({ routename, refreshList }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();

  const handleDelete = () => {
    setOpenDialog(true);
    // refreshList();
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleConfirmDelete = async () => {
    try {
      const { data } = await delete_booking_dynamic_route(routename?._id);

      setOpenDialog(false);
      toast.success(
        data?.data?.message || "Booking Route deleted successfully"
      );
      if (refreshList) {
        refreshList();
      }
    } catch (error) {
      toast.error("Something went wrong while deleting the route");
    }
  };

  console.log(routename?.status, "this is route status");

  return (
    <div
      style={{
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "4px",
      }}
    >
      <div style={{ marginBottom: "12px", fontWeight: 500 }}>
        <Tooltip title={routename?.route || ""} arrow>
          <p
            style={{
              fontSize: "1.5rem",
              fontWeight: 500,
              color: "black",
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              paddingBottom: "10px",
            }}
          >
            Route Name : {routename?.route}
          </p>
          <p
            style={{
              fontSize: "1rem",
              fontWeight: 500,
              color: "black",
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
            }}
          >
            {" "}
            Route Status : {routename?.status ? "Active" : "InActive"}
          </p>
        </Tooltip>
      </div>

      <div style={{ textAlign: "right" }}>
        <IconButton
          size="small"
          onClick={() => {
            navigate("/dashboard/bookinglocation/add-dynamic-location-routes", {
              state: { id: routename?._id }, // 👈 just pass the id
            });
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={handleDelete}>
          <DeleteIcon fontSize="small" />
        </IconButton>
        {/* <ToastContainer /> */}
        {/* confirmation popup */}
        <Dialog open={openDialog} onClose={""}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            <p style={{ fontSize: "16px", fontFamily: "sans-serif" }}>
              Are you sure you want to delete this category:
              {/* <b>{pagecategorylist?.category}</b>? */}
            </p>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              color="error"
              variant="contained"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default CardPageCategory;
